import React from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className="flex items-center space-x-1">
      <button
        onClick={() => changeLanguage('ja')}
        className={`px-2 md:px-3 py-1 rounded-md text-xs md:text-sm font-medium transition-colors ${
          i18n.language === 'ja'
            ? 'bg-blue-600 text-white'
            : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
        }`}
      >
        <span className="hidden sm:inline">日本語</span>
        <span className="sm:hidden">JP</span>
      </button>
      <button
        onClick={() => changeLanguage('en')}
        className={`px-2 md:px-3 py-1 rounded-md text-xs md:text-sm font-medium transition-colors ${
          i18n.language === 'en'
            ? 'bg-blue-600 text-white'
            : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
        }`}
      >
        <span className="hidden sm:inline">English</span>
        <span className="sm:hidden">EN</span>
      </button>
    </div>
  );
};

export default LanguageSwitcher;